import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Field from './Field';
import { ConnectedPaxFragment } from '../MobileFragments/PaxFragment';
import { isCurrentSearchPopulated, totalPax, isTrainsProductActive } from '../../../redux/currentSearch/selectors';
import { ABUtils, Config } from '../../../utils';
import { FieldType, FlightClass, FlightClassCMS, FlightClassProp, TripType } from '../../../models';


const PaxFieldSeparator = ({ showTitle, isTrainsProduct }) => {
    return (showTitle && !isTrainsProduct) ? (
        <React.Fragment>
            <div className="odf-stroke-primary odf-space-outer-top-l odf-space-outer-bottom-m" />
        </React.Fragment>
    ): <></>;
};

export const PaxField = ({ pax, cabinClass, showTitle, isHotelOptionEnabled }) => {
    const { t } = useTranslation();
    const isTrainsProduct = useSelector((state) => isTrainsProductActive(state));
    const hasCurrentSearchPopulated = useSelector((state) => isCurrentSearchPopulated(state));
    const { isCssVariationMobile } = ABUtils.getABs();
    const direction = Config.get('isRtl') ? 'rtl' : 'ltr';
    const isOneEntryPointEnabled = Config.get('isOneEntryPointEnabled');
    const showOneEntryPoint = isOneEntryPointEnabled && !hasCurrentSearchPopulated;
    const paxLabel = t('flightsManager.passengers', {
        count: pax,
    });
    const placeHolder = isCssVariationMobile ? t('flightsManager.selection.pax.title') : '';
    const cabinLabel = t(FlightClassCMS[cabinClass]);
    let label;
    if (direction === 'rtl') {
        label = isTrainsProduct ? paxLabel : [cabinLabel, paxLabel].join(', ');
    } else {
        label = isTrainsProduct ? paxLabel : [paxLabel, cabinLabel].join(', ');
    }
    return (
        <React.Fragment>
            <PaxFieldSeparator showTitle={showTitle} isTrainsProduct={isTrainsProduct} />
            { !showOneEntryPoint && (
                <Field icon="pax" id={FieldType.PAX} value={label} placeholder={placeHolder} />
            )}
            <ConnectedPaxFragment isHotelOptionEnabled={isHotelOptionEnabled} />
        </React.Fragment>
    );
};

PaxField.propTypes = {
    pax: PropTypes.number,
    cabinClass: FlightClassProp,
    showTitle: PropTypes.bool.isRequired,
};

PaxField.defaultProps = {
    pax: 1,
    cabinClass: FlightClass.TOURIST,
};

const mapStateToProps = (state) => ({
    pax: totalPax(state),
    cabinClass: state.currentSearch.cabinClass,
    showTitle: state.currentSearch.tripType !== TripType.ROUND_TRIP,
});

export const ConnectedPaxField = connect(mapStateToProps)(PaxField);
